import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
import { RolService } from './rol.service';
import { Router } from '@angular/router';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  baseUrl = `${this.env.URL_API}/usuario`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');

  constructor(
    private http: HttpClient,
    private socket: Socket,
    private _roles: RolService,
    private router: Router,
    private env: EnvService
  ) { }

  doLogout() {
    this._roles.permisos = [];
    this._roles.setValues();
    this.socket.emit('desconectar', sessionStorage.getItem('id_usuario'));
    sessionStorage.clear();
    this.router.navigate(['']);
  }

  createUser(user: any): Observable<any> {
    const url = this.baseUrl;
    return this.http.post(url, user);
  }

  getUsers(): any {
    return this.http.get(`${this.baseUrl}`);
  }

  getUsersAD() {
    return this.http.get(`${this.baseUrl}AD`);
  }

  // User profile
  getUserProfile(id: number): Observable<any> {
    if (id) {
      const url = `${this.baseUrl}/${id}`;
      return this.http.get(url, { headers: this.headers }).pipe(
        map((res: Response) => {
          return res || {};
        }),
        catchError(this.handleError)
      );
    }
  }

  getUserById(id: number): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get(url);
  }

  updateUser(id, user): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    return this.http.put(url, user, { headers: this.headers });
  }
  updateProfile(id, user): Observable<any> {
    const url = ` ${this.env.URL_API}/usuario_profile/${id}`;
    return this.http.put(url, user, { headers: this.headers });
  }
  updatePhoto(id, data): Observable<any> {
    const url = ` ${this.env.URL_API}/usuario_profilePhoto/${id}`;
    return this.http.put(url, data);
  }
  updatePassword(id, user): Observable<any> {
    const url = ` ${this.env.URL_API}/usuario_password/${id}`;
    return this.http.put(url, user, { headers: this.headers });
  }

  deleteUser(id, userId): Observable<any> {
    const url = `${this.baseUrl}/${id}`;
    const httpOptions = {
      headers: this.headers,
      body: { id_usuarios_creador: userId },
    };
    return this.http
      .delete(url, httpOptions)
      .pipe(catchError(this.handleError));
  }

  // Error
  handleError(error: HttpErrorResponse) {
    let msg = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      msg = error.error.message;
    } else {
      // server-side error
      msg = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(msg);
  }
}
